// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xs-1";
export var printerIcon = "_xs-0";